import type { UserRoles } from "~enums/userRoles";
import type { LabelValue } from "~types/labelValue";
import type { PermissionScope } from "~types/permissionScope";
import type { UserPermissionTransformed } from "../../types";
import { SELECT_ALL_VALUE } from "../constants/ui";
import type { UserPermissionForm } from "../types";

const getFormInitialValues = (
  userPermission: UserPermissionTransformed | undefined,
  scopeData: PermissionScope | undefined,
  fixtureStatusesOptions: LabelValue[],
  seasonStatusesOptions: LabelValue[],
): UserPermissionForm => {
  if (!userPermission) {
    return {
      userRole: null,
      scope: scopeData?.isFullScope ? SELECT_ALL_VALUE : null,
      scopeValues: null,
      seasonStatuses: seasonStatusesOptions.map(({ value }) => value),
      fixtureStatuses: fixtureStatusesOptions.map(({ value }) => value),
    };
  }

  const { userRole, scope, scopeValues, seasonStatuses, fixtureStatuses } = userPermission;

  return {
    scopeValues,
    userRole: userRole as UserRoles,
    scope: scope === null ? SELECT_ALL_VALUE : scope,
    seasonStatuses: seasonStatuses ?? seasonStatusesOptions.map(({ value }) => value),
    fixtureStatuses: fixtureStatuses ?? fixtureStatusesOptions.map(({ value }) => value),
  };
};

export default getFormInitialValues;
